var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open-window-page"},[_c('div',[_vm._v("OpenWindowPage")]),_c('el-button',{on:{"click":_vm.open}},[_vm._v("open")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }